import { useEffect, useState } from 'react';

import { useDataProvider, useNotify } from 'ra-core';
import { useFormContext, useWatch } from 'react-hook-form';
import { OfferOptionDto, OfferOptionTypeDto } from 'src/dtos';

export const useSetOfferFormHiddenValues = () => {
  const categoryId = useWatch({ name: 'categoryId' });
  const [category, setCategory] = useState<OfferOptionDto>();
  const statusId = useWatch({ name: 'statusId' });
  const [status, setStatus] = useState<OfferOptionDto>();

  const { setValue } = useFormContext();
  const dataProvider = useDataProvider();
  const notify = useNotify();

  useEffect(() => {
    if (category?.name) {
      setValue('_categoryName', category.name, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
  }, [category, setValue]);

  useEffect(() => {
    if (status?.name) {
      setValue('_statusName', status.name, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true,
      });
    }
  }, [status, setValue]);

  useEffect(() => {
    if (categoryId) {
      dataProvider
        .getOne('offer-options', {
          id: categoryId,
          meta: { type: OfferOptionTypeDto.CATEGORY },
        })
        .then(({ data }) => {
          setCategory(data);
        })
        .catch(error => {
          notify(error.message, {
            type: 'error',
            autoHideDuration: 7500,
          });
        });
    }
  }, [categoryId, setValue]);

  useEffect(() => {
    if (statusId) {
      dataProvider
        .getOne('offer-options', {
          id: statusId,
          meta: { type: OfferOptionTypeDto.STATUS },
        })
        .then(({ data }) => {
          setStatus(data);
        })
        .catch(error => {
          notify(error.message, {
            type: 'error',
            autoHideDuration: 7500,
          });
        });
    }
  }, [statusId]);

  return null;
};
